export default __webpack_public_path__ + "static/media/Billing.57c70094.svg";